<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">ขอพิมพ์นามบัตร</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอพิมพ์นามบัตร
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ขอพิมพ์นามบัตร
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="mt-2 mt-lg-2">
            <ul class="list-group">
              <li class="list-group-item list-group-item-action blue-1">
                <div
                  class="
                    col-12
                    d-flex
                    flex-row flex-wrap
                    justify-content-between
                  "
                >
                  <div class="text-start gary-3 fw-normal font-family fs-5">
                    ประเภทนามบัตร<span class="required">*</span>
                  </div>
                  <div class="text-end">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      @click="CheckAll()"
                      v-model="isCheckAll"
                    /><label class="fw-normal font-family fs-5 ps-1"
                      >เลือกทั้งหมด</label
                    >
                  </div>
                </div>
              </li>
              <li
                class="
                  list-group-item list-group-item-action
                  blue-1
                  fs-5
                  fw-normal
                  font-family
                "
                v-for="lang in langsdata"
                :key="lang.id"
              >
                <div class="col-12 row">
                  <div style="width: auto">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      :key="lang.id"
                      :value="lang.detail"
                      v-model="languages"
                      @change="UpdateCheckall(lang.id)"
                    />
                    <!-- :key="lang.id" :value="lang.detail" -->
                    <label class="ps-2">{{ lang.detail.name }}</label>
                  </div>
                  <Transition name="slide-fade">
                    <div v-if="lang.show" style="width: auto; padding: 0">
                      <input
                        type="text"
                        class="Print__input fs-6 bla-placeholder"
                        style="font-family: monospace;"
                        autocomplete="off"
                        size="5"
                        placeholder="จำนวน"
                        maxlength="3"
                        :id="'input__' + lang.id"
                        v-model="lang.detail.valuebox"
                        @keypress="isNumber($event)"
                      /><label class="ps-2">กล่อง</label>
                    </div>
                  </Transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="pb-3 pb-lg-3">
          <div class="gray-3 fs-5 d-lg-inline-block mt-lg-2 font-family">
            ข้อมูลเพิ่มเติม :
          </div>
          <div class="fs-4 font-family">
            <textarea v-model="AD_INFO_DETAIL" class="field field__input a-field__input border-none" style="border-bottom: 1px solid #d0d0d0; resize: none; height: 80px;" aria-label="With textarea" placeholder="ข้อมูลเพิ่มเติม" maxlength="254"></textarea>
          </div>
        </div>
        <div class="col mt-2">
          <button class="btn-CB border border-0 rounded w-100 font-family" @click="EnterNext()">
            <label class="href-CB" style="cursor: pointer;">ดำเนินการต่อ</label>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "PrintCardView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      Loading : true,
      show: false,
      isCheckAll: false,
      languages: [],
      langsdata: [
        {
          id: 1,
          detail: {
            name: "ตัวแทนประกันชีวิต",
            value: "AG",
            valuebox: '',
          },
          show: false,
        },
        {
          id: 2,
          detail: {
            name: "ผู้แนะนำการลงทุน",
            value: "FA",
            valuebox: '',
          },
          show: false,
        },
      ],
      AD_INFO_DETAIL: '',
      AMOUNT: 0,
    };
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?",{ headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => { 
      if(res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.Loading = false;
      }
      else { 
        this.Loading = false; 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => { 
      this.Loading = false;
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">'+ error.response.data.ErrorMessage +'</label>',
      }).then(() => { 
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });
  },
  methods: {
    CheckAll() {
      this.isCheckAll = !this.isCheckAll;
      this.languages = [];
      if (this.isCheckAll) {
        // Check all
        for (var key in this.langsdata) {
          this.languages.push(this.langsdata[key].detail);
          this.langsdata[key].show = true;
        }
      } else {
        for (var key in this.langsdata) {
          this.langsdata[key].show = false;
        }
      }
    },
    UpdateCheckall(id) {
      this.langsdata[id - 1].show = !this.langsdata[id - 1].show;
      if (this.languages.length == this.langsdata.length) {
        this.isCheckAll = true;
      } else {
        this.isCheckAll = false;
      }
    },
    EnterNext() {
      if(this.languages.length <= 0) { 
        Swal.fire({
        icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาเลือกประเภทนามบัตร</label>',
        });
      }
      else {
        let CheckBoxs = 0;
        this.languages.forEach(item => {
          if(item.valuebox === '' || item.valuebox == 0) {
            CheckBoxs++;
          }
        });

        if(CheckBoxs > 0) {
          Swal.fire({
          icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">กรุณากรอกจำนวนกล่องให้ครบทุกช่อง หรือกรอกจำนวนกล่อง</label>',
          });
        }
        else {
          //SET INSERT DATA
          this.$store.state.CARD_PRINT.CRAD = [];
          this.languages.forEach(item => {
            let params = {
              CARD_TYPE: item.value,
              AMOUNT: parseInt(item.valuebox)
            };
            this.$store.state.CARD_PRINT.CRAD.push(params);
          });
          this.$store.state.CARD_PRINT.AD_INFO_DETAIL = this.AD_INFO_DETAIL;

          this.$router.push('/FinishPrintCard');
        }
      }
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      let key = evt.key;
      let re = /^\d+.?\d*$/;
      if (re.test(key)) {
        return true;
      } else {
        evt.preventDefault();
      }
    }
  },
};
</script>

<style scoped>
.Print__input {
  border-bottom: 1px solid rgb(208, 208, 208) !important;
  background-color: transparent;
  border: none;
  font-family: inherit;
  font-size: 1.375rem;
  color: #0057a8;
  size: 20px;
  text-align: center;
  margin-top: -1px;
}
.Print__input:focus {
  outline: none;
  text-align: center;
}

.Print__input::placeholder {
  font-size: 0.8em;
  text-align: center;
}

.border-none:focus {
  outline: none;
}

.btn-CB {
  min-height: 50px;
  font-size: 26px;
  font-size: 1.625rem;
  background-color: #0057a8;
  
}
.href-CB {
  color: #ffffff;
}

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>